/* eslint-disable */
import { ErrorHelper } from '../../helpers/ErrorHelper';
import { mapState, mapActions } from 'vuex';
import { SelectedSiteIdMixin } from './SelectedSiteIdMixin'

export const PreferredResourceCacheMixin = {
    mixins: [SelectedSiteIdMixin],
    data() {
        return {
            error: ''
        }
    },
    computed: {
        ...mapState('PreferredResources', [
            'preferredResources',
            'loadingPreferredResources',
            'retryPreferredResources'
        ])
    },
    watch: {
        selectedSiteId() {
            this.refreshPreferredResources();
        }
    },
    methods: {
        ...mapActions('PreferredResources', [
            'getPreferredResourcesBySiteId'
        ]),
        refreshPreferredResources() {
            if (this.preferredResources.length == 0 || !!this.retryPreferredResources) {
                this.tryGetPreferredResourcesBySiteId();
            }
        },
        tryGetPreferredResourcesBySiteId() {
            const self = this;
            self.error = '';
            if(!self.selectedSiteId) {
                return;
            }
            self.getPreferredResourcesBySiteId(self.selectedSiteId)
                .catch(error => ErrorHelper.getError(error));
        }
    },
    created() {
        this.refreshPreferredResources();
    }
}
